// 文字内容
export const expirationText = {
    0: '', // 正常
    1: '临期',
    2: '已过期',
};
// 边框、文字颜色
export const expirationBorderColor = {
    0: '',
    1: '#ff9900', // 黄色
    2: '#f00', // 红色
};
